/**
 * @module Entry-Model component
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const EntryModalConstants = {
  PREPAID: 'prepaid',
  POSTPAID: 'postpaid',
};
